import abstractModel from '../../core/MercatelyModel';
import { MERCATELY_API } from '../../constants/AppConstants';

const RESOURCE = `${MERCATELY_API}/whatsapp_flows`;

const model = abstractModel(RESOURCE);

model.sync = () => model.post({}, { path: `${RESOURCE}/sync` });
model.sendMessage = (payload) => model.post(payload, { path: `${RESOURCE}/send_message` });
model.trackEvent = (event) => model.post({ event }, { path: `${RESOURCE}/track_event` });
// Reported separately when the flow is sent through the inbox microservice,
// where Rails never sees the send.
model.trackFlowSent = (flowId) => model.post(
  { event: 'flow_sent', flow_id: flowId },
  { path: `${RESOURCE}/track_event` }
);
model.getDetail = (metaFlowId) => model.get({}, { path: `${RESOURCE}/${metaFlowId}` });
model.getResponses = (metaFlowId, params = {}) => model.get(params, { path: `${RESOURCE}/${metaFlowId}/responses` });
model.exportResponses = (metaFlowId) => model.post({}, { path: `${RESOURCE}/${metaFlowId}/export_responses` });

export default model;
